<div fxLayout="row" fxLayoutAlign="center" class="mt-2">
  <div fxFlex="100" fxFlex.gt-sm="1 1 400px" fxFlex.sm="1 1 400px" class="mat-elevation-z6 p-3">
    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
      <h1>{{ 'APP.FIND-FREE-TIME' | translate }}</h1>

      <mat-form-field class="w-100">
        <mat-label>{{ 'COMMON.SEARCH-BY-NAME-PHONE-ID' | translate }} <span class="accent-color">*</span></mat-label>
        <input 
        type="text" 
        placeholder="{{ 'COMMON.SEARCH-BY-NAME-PHONE-ID' | translate }}*" 
        aria-label="Patient"
        matInput 
        #trigger="matAutocompleteTrigger" 
        formControlName="patient" 
        [matAutocomplete]="auto" 
        (keyup)="search($event, trigger)">
        <mat-icon matSuffix (click)="searchButtonClicked($event, trigger)">search</mat-icon>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let currentPatient of patients | async" [value]="currentPatient" class="optionItem"
            (onSelectionChange)="onPatientSelected($event, currentPatient)">
            <div fxLayout="row" class="h-100" fxLayoutAlign="stretch center" fxLayoutGap="10px">
              <div>
                <div class="circle" [class.active]="currentPatient.Active"></div>
              </div>
              <div fxFlex>
                <div [innerHtml]="currentPatient.Label1"></div>
                <div *ngIf="!canWatchConfidential(currentPatient)">
                  {{ 'COMMON.NO-PERMISSION-TO-CONFIDENTIAL' | translate }}</div>
                <div *ngIf="canWatchConfidential(currentPatient)"> {{ 'COMMON.AGE' | translate }}
                  {{ currentPatient.Age || '-' }}</div>
                <div *ngIf="canWatchConfidential(currentPatient)"> {{ currentPatient.Phone }} <span
                    *ngIf="currentPatient.Phone2">| {{ currentPatient.Phone2 }}</span></div>
              </div>
            </div>
          </mat-option>
        </mat-autocomplete>

        <a mat-button *ngIf="form.controls.patient.value" matSuffix mat-icon-button aria-label="Clear"          
          (click)="onClearPatient($event)">
          <mat-icon>close</mat-icon>
      </a>

        <!-- <mat-hint *ngIf="(patients | async)?.length==0" style="color: red;">{{ 'SCHEDULER.NO-DATA-FOUND' | translate}}</mat-hint> -->
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>{{ 'SCHEDULER.SELECT-PRACTICE' | translate }} <span class="accent-color">*</span></mat-label>
        <mat-select placeholder="{{ 'SCHEDULER.SELECT-PRACTICE' | translate }}*" formControlName="practice">
          <mat-option value="">{{ 'COMMON.NONE' | translate }}</mat-option>
          <mat-option *ngFor="let currentPractice of practices" [value]="currentPractice.ID">
            {{currentPractice.Name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-select placeholder="{{ 'SCHEDULER.SELECT-BRANCH' | translate }}" formControlName="branch">
          <mat-option value="">{{ 'COMMON.NONE' | translate }}</mat-option>
          <mat-option *ngFor="let currentBranch of branches" [value]="currentBranch.BranchID">
            {{currentBranch.BusinessName}} {{ currentBranch.Address}} </mat-option>
        </mat-select>
        <button mat-button *ngIf="form.controls.branch.value" matSuffix mat-icon-button aria-label="Clear"
          (click)="clearBranch($event)">
          <mat-icon>close</mat-icon>
        </button>
        <mat-error *ngIf="form.controls.branch.errors?.required">{{ 'ERROR.BRANCH-REQUIRED' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-select placeholder="{{ 'SCHEDULER.SELECT-THERAPIST' | translate }}" formControlName="scheduler">
          <mat-option value="">{{ 'COMMON.NONE' | translate }}</mat-option>
          <mat-option *ngFor="let currentScheduler of schedulers" [value]="currentScheduler.ID">
            {{currentScheduler.Name}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.scheduler.errors?.required">{{ 'ERROR.SCHEDULER-REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>

      <app-treatment-selection
      [treatments]="treatments"
      [priceListCodes]="priceListCodes"
      [isReasonRequired]="isReasonRequired"
      [schedulers]="schedulers"
      [branches]="branches"
      [hasTreatmentsTodo]="form.controls.hasTreatmentsTodo.value"
      [patientID]="selectedPatientID"
      [branchID]="form.controls.branch.value"
      [practiceID]="form.controls.practice.value"
      [scheduler]="form.controls.scheduler.value"
      (onSelectVisitReasonClick)="onSelectVisitReasonFromChild($event)"
      (onClearPriceListCodeClick)="onClearPriceListCodeFromChild($event)"
      (onClearTreatmentClick)="onClearTreatmentFromChild($event)"
      (onClearVisitReasonClick)="onClearVisitReasonFromChild($event)"></app-treatment-selection>


      <!-- <div>
        <mat-label>{{ 'FIND-TIME.VISIT-REASON' | translate }} <span *ngIf="isReasonRequired" class="accent-color">*</span></mat-label>
        <button mat-stroked-button type="button" color="primary" class="m-2"
          (click)="onSelectVisitReason('select-from-pricelist')" aria-label="price-list"
          [disabled]="!(form.value.practice && form.value.patient)">
          {{ 'FIND-TIME.FROM-PRICELIST' | translate }}
        </button>
        <button mat-stroked-button type="button" type="button" color="primary"
          (click)="onSelectVisitReason('select-from-card')" aria-label="treatment-card"
          [disabled]="!(form.value.practice && form.value.patient  && form.value.hasTreatmentsTodo)">
          {{ 'FIND-TIME.FROM-TREATMENT-CARD' | translate }}
        </button>
      </div>

      <div class="w-100" fxLayout="column">
        <h4>{{ 'FIND-TIME.TREATMENTS-FOR-APPOINTMENT' | translate }}:
          <button mat-button *ngIf="form.get('reason').value" matSuffix mat-icon-button aria-label="Clear"
            (click)="onClearVisitReason($event)">
            <mat-icon style="font-size:13px;">close</mat-icon>
          </button>
        </h4>

       
        <div *ngFor="let treatmentItem of treatments">
          <span>{{ getTreatmentSummary(treatmentItem) }}</span>
          <button mat-button matSuffix mat-icon-button aria-label="Clear"
            (click)="onClearTreatment($event, treatmentItem)" class="md-26">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div *ngFor="let pricelistCodeItem of priceListCodes">
          <span>{{ getPriceListSummary(pricelistCodeItem) }}</span>
          <button mat-button matSuffix mat-icon-button aria-label="Clear"
            (click)="onClearPriceListCode($event, pricelistCodeItem)" class="md-26">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div> -->

      


      <mat-form-field class="w-100">
        <mat-label *ngIf="isRoomRequired">{{ 'SCHEDULER.SELECT-ROOM' | translate }} <span class="accent-color">*</span></mat-label>
        <mat-select placeholder="{{ 'SCHEDULER.SELECT-ROOM' | translate }}" formControlName="room">
          <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
          <mat-option *ngFor="let currentRoom of rooms" [value]="currentRoom.Value">
            {{currentRoom.Text}} </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="w-100 mb-3" fxLayout="row wrap" fxLayoutGap="7px">
        <mat-checkbox *ngIf="firstDayOfWeek == 0" formControlName="sunday" color="primary">
          {{ 'DAYSOFWEEK.SUN' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="monday" color="primary">{{ 'DAYSOFWEEK.MON' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="tuesday" color="primary">{{ 'DAYSOFWEEK.TUE' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="wednesday" color="primary">{{ 'DAYSOFWEEK.WED' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="thursday" color="primary">{{ 'DAYSOFWEEK.THU' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="friday" color="primary">{{ 'DAYSOFWEEK.FRI' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="saturday" color="primary">{{ 'DAYSOFWEEK.SAT' | translate }}</mat-checkbox>
        <mat-checkbox *ngIf="firstDayOfWeek == 1" formControlName="sunday" color="primary">
          {{ 'DAYSOFWEEK.SUN' | translate }}</mat-checkbox>
      </div>

      <mat-form-field class="ml-3">
        <mat-label>{{ 'COMMON.FROM-DATE' | translate }}</mat-label>
        <input matInput [matDatepicker]="startDatepicker" formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatepicker></mat-datepicker>
      </mat-form-field>

      <div fxLayout="row wrap">

         <mat-form-field class="ml-3" style="max-width: 90px;">
          <mat-label>{{ 'COMMON.FROM-TIME' | translate }}</mat-label>
          <mat-select placeholder="{{ 'COMMON.FROM-TIME' | translate }}" formControlName="startTime">
          <!--   <mat-option *ngFor="let currentTime of fromTimeList" [value]="currentTime.Value">
              {{currentTime.Text}} </mat-option>-->
              <mat-option *ngFor="let currentTime of startTimeList" [value]="currentTime.Value">
                {{ currentTime.Text }} </mat-option>
          </mat-select> 
           <mat-error *ngIf="form.controls.startTime.hasError('startTimeGreaterThanEndTime')"> 
            {{ 'ERROR.END-TIME-SMALLER-THEN-START-TIME' | translate}}
          </mat-error> 
        </mat-form-field>

        <mat-form-field class="ml-3" style="max-width: 90px;">
          <mat-label>{{ 'COMMON.TO-TIME' | translate }}</mat-label>
          <mat-select placeholder="{{ 'COMMON.TO-TIME' | translate }}" formControlName="endTime">
            <mat-option *ngFor="let currentTime of endTimeList" [value]="currentTime.Value">
              {{currentTime.Text}} </mat-option>
          </mat-select> 
        </mat-form-field> 

        <mat-form-field class="ml-3" style="width: 4em;">
          <mat-label>{{ 'COMMON.DURATION' | translate }}</mat-label>
          <input type="number" [attr.min]="minDuration" [attr.max]="maxDuration" step="5" matInput
            placeholder="{{ 'COMMON.DURATION' | translate }}" formControlName="duration" (blur)="onDurationChanged()">
          <mat-error *ngIf="form.controls.duration.errors?.required">{{ 'ERROR.DURATION-REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="form.controls.duration.hasError('min')">{{ 'ERROR.DURATION-MIN-INVALID' |translate: {
            'minutes': 5 } }}</mat-error>
          <mat-error *ngIf="form.controls.duration.hasError('max')">{{ 'ERROR.DURATION-MAX-INVALID' |translate: {
            'minutes': 120 } }}</mat-error>
        </mat-form-field>

        <mat-error *ngIf="error" fxLayoutAlign="center" class="w-100 pb-3 alert alert-danger">{{error}}</mat-error>
        <div fxLayoutAlign="center" class="w-100">

          <button mat-raised-button color="accent" class="mat-elevation-z6 ml-3" type="submit" [disabled]="!form.valid">{{
          'COMMON.SEARCH' | translate }}</button>

          <button mat-raised-button class="mat-elevation-z6 ml-3" type="button" (click)="onCancel($event)">{{
          'COMMON.CANCEL' | translate }}</button>

        </div>
      </div>
    </form>
  </div>

</div> 




   <div class="w-100" style="word-wrap: break-word;">
   <!-- {{ diagnostic }} -->
    <!--  <div>{{ f.room.value }}</div> -->
    <!--   <div>{{ form.valid }}</div> -->
</div>

